import { useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useJourney } from "../JourneyContext";
import { ContinueButton, StageFrame } from "../StageChrome";
import { WORLD_PORTALS } from "../intentionData";

export const WorldStage = () => {
  const { journey, completeStage } = useJourney();
  const restored = useMemo(() => Object.fromEntries((journey.signals.worlds || []).map((item) => [item.key, item])), [journey.signals.worlds]);
  const [selected, setSelected] = useState(restored);
  const enteredAt = useRef({});
  const order = useRef(Object.keys(restored));

  const pullCloser = (portal) => {
    setSelected((current) => {
      if (current[portal.key]) {
        const next = { ...current }; delete next[portal.key];
        order.current = order.current.filter((item) => item !== portal.key);
        return next;
      }
      if (Object.keys(current).length >= 5) return current;
      order.current.push(portal.key);
      return { ...current, [portal.key]: { key: portal.key, weight: .72, order: order.current.length - 1 } };
    });
  };

  const recordLinger = (key) => {
    const started = enteredAt.current[key];
    if (!started) return;
    const seconds = Math.min(8, (performance.now() - started) / 1000);
    setSelected((current) => current[key] ? { ...current, [key]: { ...current[key], weight: Math.min(1, .72 + seconds * .035) } } : current);
    delete enteredAt.current[key];
  };

  const finish = () => completeStage("worlds", order.current.filter((key) => selected[key]).map((key, index) => ({ ...selected[key], order: index })));

  return (
    <StageFrame eyebrow="THE WORLD" title="Where does your attention naturally go?" instruction="Move toward whatever pulls you." className="world-stage" testId="stage-1-world">
      <div className="world-field" data-testid="stage-1-world-field">
        <div className="world-field-core" aria-hidden="true">YOU</div>
        {WORLD_PORTALS.map((portal, index) => {
          const active = Boolean(selected[portal.key]);
          return <motion.button key={portal.key} type="button" drag dragElastic={.18} dragMomentum={false} whileDrag={{ scale: 1.14, zIndex: 20 }} onDragEnd={() => !active && pullCloser(portal)} onClick={() => pullCloser(portal)} onPointerEnter={() => { enteredAt.current[portal.key] = performance.now(); }} onPointerLeave={() => recordLinger(portal.key)} aria-pressed={active} className={`world-portal ${active ? "is-pulled" : ""}`} style={{ "--x": `${portal.x}%`, "--y": `${portal.y}%`, "--size": `${portal.size}px`, "--delay": `${index * -.4}s` }} data-testid={`stage-1-portal-${portal.key.toLowerCase()}`}><img src={portal.image} alt="" loading="lazy" /><span>{portal.key}</span><i /></motion.button>;
        })}
        <div className="world-signal-count" data-testid="stage-1-signal-count"><strong>{Object.keys(selected).length}</strong><span>worlds moving closer</span></div>
      </div>
      <ContinueButton onClick={finish} disabled={Object.keys(selected).length < 3} label="Follow the pull" testId="stage-1-continue-button" />
    </StageFrame>
  );
};